import React from 'react'
import { string, arrayOf } from 'prop-types'
import Sticky from 'react-stickynode'
import styled from 'styled-components'

import ScrollSpyNav from 'components.v2/ScrollSpyNav'
import Text from 'components.v2/Text'
import { mobileFirstMedia as media } from 'utils/media'

const STICKY_OFFSET = 0 // height of venue header
const STICKY_OFFSET_OFFLINE = 52
const SCROLL_OFFSET = 60 // sum of height of venue header and height of sticky category nav
const SCROLL_OFFSET_OFFLINE = 112

const MenuCategory = ({ categories, isOffline }) => (
  <Sticky
    top={isOffline ? STICKY_OFFSET_OFFLINE : STICKY_OFFSET}
    bottomBoundary="#sticky-categories-boundary"
    innerZ={1}
  >
    <ScrollSpyNav
      list={categories}
      scrollLinkProps={{
        offset: -(isOffline ? SCROLL_OFFSET_OFFLINE : SCROLL_OFFSET),
      }}
      renderContainer={MenuCategoryContainer}
      renderItem={MenuCategoryItem}
      alwaysShowActive
    />
  </Sticky>
)

MenuCategory.propTypes = {
  categories: arrayOf(string),
}

export default MenuCategory

export const MenuCategoryContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.colors.white};
  height: 60px;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  align-items: center;
  overflow-x: auto;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  ::-webkit-scrollbar {
    display: none;
  }

  ${media.screen`
    height: 65px;    
  `}
`

export const MenuCategoryItem = styled(Text)`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  height: 28px;
  padding: 4px 12px;
  border-bottom: 2px solid transparent;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  color: ${props => props.theme.colors.orange} !important;
  vertical-align: middle;

  ${media.screen`
    padding: 0 15px;
    height: 65px;
    color: #333;
  `}

  &.active {
    background: #f26722;
    border-radius: 16px;
    color: #ffffff !important;

    ${media.screen`
      border-bottom-color: ${props => props.theme.colors.orange};
      color: ${props => props.theme.colors.orange} !important;
    `}
  }
`
